











































































































































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import CardHeader from '@/components/Registration/Header.vue';
import Container from '@/components/Registration/Container.vue';
import RegistrationCard from '@/components/Registration/Card.vue';
import BasicSignupForm from './BasicSignupForm.vue';
import SignupFooter from './Footer.vue';
import { PilotSignUP } from '../../models/jobrolesignup/pilotsignup';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { User } from '../../models/userdata/userdto';
import basicFormValidator from './basicFormValidator';
import MultipleSelectWithCheckbox from '@/components/Commons/MultipleSelectWithCheckbox.vue';
import { ModelListSelect } from 'vue-search-select';
import { airlineCompanies } from './airlineCompanies';
import pilotSignupValidator from './pilotSignupValidator';
import Multiselect from 'vue-multiselect';
@Component({
  components: {
    Multiselect,
    CardHeader,
    Container,
    RegistrationCard,
    BasicSignupForm,
    SignupFooter,
    Datepicker,
    ModelListSelect,
    MultipleSelectWithCheckbox,
  },
})
export default class PilotSignup extends Mixins(
  basicFormValidator,
  pilotSignupValidator,
) {
  $wlToastr: any;
  $moment: any;
  private basicFormValues = new User();
  private isTypeable: boolean = true;

  addTag(newTag) {
    const tag = {
      text: newTag,
      value: newTag,
    };
    this.airlineCompanies.push(tag);
    this.pilotSignUP.latestAirlineCompany = tag;
  }

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }
  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }
  mounted() {
    vxm.roleSignup.setMarketingMail(false);
    vxm.passport.fetchCountryList();
    vxm.roleSignup.fetchPilotLicenseCategory();
    vxm.roleSignup.fetchJobHistoryMetaData();
    vxm.roleSignup.fetchChildCompanies();
  }
  get passportCountries() {
    return vxm.passport.CountryList;
  }
  get airlineCompanies() {
    return vxm.roleSignup.ChildCompanies.map((opt) => {
      return {
        value: opt.name,
        text: opt.name,
      };
    });
  }
  get licenseAuthorityOptions() {
    return vxm.configs.getGlobalConfigValue('LICENCE_AUTHORITY').map((opt) => {
      return {
        value: opt,
        text: opt,
      };
    });
  }

  get licenseTypeOptions() {
    return vxm.roleSignup.PilotLicenseCategories;
  }
  get fleetOptions() {
    return vxm.roleSignup.PilotFleetOptions;
  }
  get rankOptions() {
    return vxm.roleSignup.PilotRankOptions;
  }

  updatePassportCountries(newValue, oldValue) {
    this.pilotSignUP.passportCountries = [];
    newValue.forEach((element) => {
      this.pilotSignUP.passportCountries.push(element.countryId);
    });
  }

  async registerUser() {
    const basicFormValid = this.validateBasicForm(this.basicFormValues);
    const pilotSignupValid = this.validatePilotSignupForm();
    const updatedSections: any = [];
    if (basicFormValid && pilotSignupValid) {
      const response = await vxm.roleSignup.basicSignup(this.basicFormValues);
      if (response.success) {
        await vxm.users.refreshProfileInfo();
        let userProfile: any = vxm.users.myUserProfile;
        userProfile.dob = vxm.utility.convertLocalTimeToUTC(
          this.pilotSignUP.dateOfBirth,
        );
        userProfile.notificationTypeMap = {
          ...userProfile.notificationTypeMap,
          MARKETING_EMAIL: vxm.roleSignup.MarketingEmail,
        };
        userProfile.totalFlightHours = this.pilotSignUP.totalHours;
        userProfile.doNotTriggerEvent = 'true';

        const licenceData = {
          licenceMasterId: Number(this.pilotSignUP.selectedLicenceType.value),
          licenceCountry: this.pilotSignUP.selectedLicence.name,
          licenceAuthority: this.pilotSignUP.licenceAuthority.value,
          licenceOn: this.pilotSignUP.selectedFleet.value,
          doNotTriggerEvent: 'true',
        };
        const jobHistoryData = {
          doNotTriggerEvent: 'true',
          companyInfo: {
            companyName: this.pilotSignUP.latestAirlineCompany.value,
          },
          currentJob: true,
          jobRole: this.pilotSignUP.otherNonFlyingPosition,
          jobHistoryCustomData: {
            [vxm.roleSignup.CustomFieldMappings.role]: 'Pilot',
            [vxm.roleSignup.CustomFieldMappings.rank]: this.pilotSignUP
              .selectedRank.value,
            [vxm.roleSignup.CustomFieldMappings.fleet]: this.pilotSignUP
              .selectedFleet.value,
            [vxm.roleSignup.CustomFieldMappings.hour]: this.pilotSignUP
              .hoursOnTypeInRank,
            [vxm.roleSignup.CustomFieldMappings
              .lastFlightDate]: vxm.utility.convertLocalTimeToUTC(
              this.pilotSignUP.lastFlightDate,
            ),
          },
          startDTTM: new Date().getTime(),
        };
        const passportData = this.pilotSignUP.passportCountries.map(
          (element) => {
            return {
              identificationMasterId: element,
              doNotTriggerEvent: 'true',
            };
          },
        );
        const formData = new FormData();
        formData.append('userProfileData', JSON.stringify(userProfile));
        formData.append('licenceData', JSON.stringify(licenceData));
        formData.append('jobHistoryData', JSON.stringify(jobHistoryData));
        formData.append('passportData', JSON.stringify(passportData));
        const response = await vxm.roleSignup.megaSignup(formData);
        if (response.meta && response.meta.success) {
          this.$router.push('home');
          this.$wlToastr(
            'success',
            'You have successfully signed up',
            'Sign up',
          );
          if (response.data) {
            if (!response.data.jobHistoryData) {
              this.$wlToastr(
                'error',
                'Work experience information not saved. Please try again from Work experience section.',
                'Sign up',
              );
            }
            if (!response.data.licenceData) {
              this.$wlToastr(
                'error',
                'Licence information not saved. Please try again from licence section.',
                'Sign up',
              );
            }
            if (!response.data.passportData) {
              this.$wlToastr(
                'error',
                'Passport information not saved. Please try again from Passport section.',
                'Sign up',
              );
            }
            if (!response.data.userProfileData) {
              this.$wlToastr(
                'error',
                'Profile information not saved. Please try again from profile section.',
                'Sign up',
              );
            }
          }
        }
      } else {
        this.$wlToastr('error', response.errorMessage, 'Sign up');
      }
    }
  }
}
